import React from 'react';
import { formatCurrency } from '../../lib/format';
import { Input } from '../ui/input';

interface MonthEarningsFieldProps {
  month: number;
  name: string;
  value: string;
  /** This month's share of the annual Tax + NI bill; hidden when the month is empty. */
  setAside: number | null;
  onChange: (value: string) => void;
}

export const MonthEarningsField: React.FC<MonthEarningsFieldProps> = ({ month, name, value, setAside, onChange }) => {
  const id = `earnings-${month}`;
  return (
    <div className="rounded-xl border border-line bg-raised/40 p-3 transition-colors focus-within:border-brand/40 focus-within:bg-raised/70">
      <div className="mb-2 flex items-baseline justify-between gap-2">
        <label htmlFor={id} className="text-[13px] font-medium text-fg-muted">
          {name}
        </label>
        {setAside !== null && (
          <span className="numeric text-[11px] text-fg-subtle">
            Set aside <span className="text-warning">{formatCurrency(setAside)}</span>
          </span>
        )}
      </div>
      <Input
        type="number"
        id={id}
        inputMode="decimal"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        step="0.01"
        min="0"
        placeholder="0.00"
        leading="£"
        className="numeric h-9"
      />
    </div>
  );
};
